"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DragAndDropOverlay;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var StyledOverlay = _styledComponents.default.div.withConfig({
  displayName: "DragAndDropOverlay__StyledOverlay",
  componentId: "sc-1ano6hy-0"
})(["transition:all 0.15s ease-out;position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;pointer-events:none;border:12px solid transparent;visibility:", ";opacity:", ";border-color:", ";"], function (props) {
  return props.isOver ? 'visible' : 'hidden';
}, function (props) {
  return props.isOver ? 1 : 0;
}, function (props) {
  return props.isOver ? _colors.CALYPSO : 'transparent';
});

function DragAndDropOverlay(props) {
  var isOver = props.isOver;
  return _react.default.createElement(StyledOverlay, {
    isOver: isOver
  });
}

DragAndDropOverlay.propTypes = {
  isOver: _propTypes.default.bool.isRequired
};
module.exports = exports.default;